import { render, staticRenderFns } from "./AddDelivery.vue?vue&type=template&id=11410d58&scoped=true&"
import script from "./AddDelivery.vue?vue&type=script&lang=js&"
export * from "./AddDelivery.vue?vue&type=script&lang=js&"
import style0 from "./AddDelivery.vue?vue&type=style&index=0&id=11410d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11410d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11410d58')) {
      api.createRecord('11410d58', component.options)
    } else {
      api.reload('11410d58', component.options)
    }
    module.hot.accept("./AddDelivery.vue?vue&type=template&id=11410d58&scoped=true&", function () {
      api.rerender('11410d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/DeliveryManagement/AddDelivery/AddDelivery.vue"
export default component.exports